import { useState } from "react";

import { ProjectIssuesTable } from "@/features/project-management/hooks/use-project-issues-table";
import { ColumnId } from "@/features/project-management/types";
import { GroupFragment } from "@/generated/graphql";

import { FilterCombobox } from "../../filter-combobox";
import { SearchMultiSelectItem } from "../../filter-combobox/filter-combobox";

export const IssueAssigneeFilter = ({
  table,
  assignees,
}: {
  table: ProjectIssuesTable;
  assignees: GroupFragment["members"];
}) => {
  const column = table.getColumn(ColumnId.Assignee)!;
  const committed = (column.getFilterValue() ?? []) as string[];

  const items: SearchMultiSelectItem[] = assignees.map((assignee) => ({
    value: assignee.id,
    label: assignee.name,
  }));

  const [selected, setSelected] = useState<string[]>(committed);

  const handleApply = () => {
    column.setFilterValue(selected);
  };

  const handleClear = () => {
    setSelected([]);
    column.setFilterValue([]);
  };

  return (
    <FilterCombobox
      items={items}
      title="Assignees"
      isSearchable={false}
      selectedItemIds={selected}
      onSelectedChange={setSelected}
      onApply={handleApply}
      onClear={handleClear}
      withIcon={true}
      withAvatar={true}
    />
  );
};
